App.OrderTimeMiniPopupComponent = Em.Component.extend
  classNames: [ 'order-time-mini-popup' ]

  env: Em.inject.service('environment')

  orderChanged: (value, name_camel, name_snake) ->
    name = "_#{name_camel}"
    if @get('_order') != @get('order')
      @set('_order',@get('order'))
      @set('_cookingStartAt', null)
      @set('_deliveryAt', null)
      @set('_pickUpAt', null)
    if value != undefined
      @set(name, value)
      return value
    @set(name, @get("order.#{name_snake}")) unless @get(name)
    @get(name)

  cookingStartAt: ((key,value)->
    @orderChanged(value, 'cookingStartAt', 'cooking_start_at')
  ).property('order', 'order.cooking_start_at','_cookingStartAt')

  deliveryAt: ((key,value)->
    @orderChanged(value, 'deliveryAt', 'delivery_at')
  ).property('order', 'order.delivery_at', '_deliveryAt')

  pickUpAt: ((key,value)->
    @orderChanged(value, 'pickUpAt', 'pick_up_at')
  ).property('order', 'order.pick_up_at', '_pickUpAt')

  timezone:       Em.computed.readOnly('order.timezone')

  warning: (->
    order = @get('order')
    unless order
      return

    cooking_start = @get('cookingStartAt')
    pick_up_at    = @get('pickUpAt')
    delivery_at   = @get('deliveryAt')

    cooking_time        = order.get('cooking_time') || 0
    transportation_time = order.get('transportation_time') || 0

    if pick_up_at && delivery_at
      trans_time = moment.duration( moment( delivery_at ).diff( pick_up_at ) ).asMinutes()

      if trans_time < transportation_time
        return @get('env').translate 'order.feasibility_warnings.transportation_time', { transportation_time, trans_time }

    if pick_up_at && cooking_start
      cook_time = moment.duration( moment( pick_up_at ).diff( cooking_start ) ).asMinutes()

      if cook_time < cooking_time
        return @get('env').translate 'order.feasibility_warnings.cooking_time', { cooking_time, cook_time }

  ).property(
    'cookingStartAt',
    'pickUpAt',
    'timezone',
    'deliveryAt',
    'order.cooking_time'
    'order.transportation_time')

  actions:
    saveChanges: ->
      order = @get('order')
      @set('isLoading', true)

      # Тут может быть неполная или неактуальная модель заказа,
      # сохраняем только время, а не всю модель
      order.nonRESTAction('PUT', '', {
        cooking_start_at: @get('cookingStartAt')
        pick_up_at:       @get('pickUpAt')
        delivery_at:      @get('deliveryAt')
      })


      # order.save()
      .then =>
        order.reload()
        .then =>
          @get('popups').send('closePopup')
        .catch =>
          false
        .finally =>
          @set('isLoading', false)

      false
